import http from './_http'

export default http
